import { createFileRoute, redirect } from "@tanstack/react-router";

/** Zone access rules now live as a tab of `/settings/zone-access`; the old address redirects (filters kept) so bookmarks work. */
export const Route = createFileRoute("/_app/settings/access-defaults")({
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/settings/zone-access", search: { ...(search as Record<string, unknown>), tab: "rules" } as never, replace: true });
	},
});
